import { render, staticRenderFns } from "./VoteComp.vue?vue&type=template&id=24f72916&scoped=true&"
import script from "./VoteComp.vue?vue&type=script&lang=js&"
export * from "./VoteComp.vue?vue&type=script&lang=js&"
import style0 from "./VoteComp.vue?vue&type=style&index=0&id=24f72916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f72916",
  null
  
)

export default component.exports